import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/site/Layout";
import { useAuth } from "@/context/AuthContext";

export default function CheckoutReturn() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("Verifying payment…");
  const [done, setDone] = useState(false);
  const { refresh } = useAuth();
  const attempts = useRef(0);
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    const poll = async () => {
      if (attempts.current >= 8) { setStatus("Timed out. Check dashboard shortly."); setDone(true); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          setStatus("Payment confirmed. Credits granted.");
          setDone(true);
          return;
        }
        if (data.status === "expired") { setStatus("Session expired."); setDone(true); return; }
        setStatus("Processing…");
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2500);
      }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <Layout>
      <div className="max-w-lg mx-auto px-6 py-32 text-center">
        <div className="overline mb-6">Checkout</div>
        <h1 className="font-serif-editorial text-5xl tracking-tighter mb-6">{done ? "Complete." : "One moment."}</h1>
        <p className="text-neutral-500 mb-10">{status}</p>
        {done && (
          <div className="flex gap-3 justify-center">
            <button onClick={() => nav("/dashboard")} className="btn-white" data-testid="return-dashboard">Dashboard</button>
            <button onClick={() => nav("/models")} className="btn-ghost">Browse</button>
          </div>
        )}
      </div>
    </Layout>
  );
}
